<template>
  <div class="xray-diffraction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>2d sinθ = nλ$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Crystal Lattice Planes -->
          <g v-for="i in 3" :key="'p'+i">
             <line x1="50" :y1="80 + i*d" x2="350" :y2="80 + i*d" stroke="rgba(255,255,255,0.1)" stroke-width="1" />
             <circle v-for="j in 10" :key="'a'+i+j" :cx="50 + j*30" :cy="80 + i*d" r="3" fill="#888" />
          </g>

          <!-- Incident X-Rays -->
          <g :transform="`rotate(${90-theta}, 200, 120)`">
             <line x1="0" y1="120" x2="200" y2="120" stroke="#ffd700" stroke-width="2" opacity="0.6" />
             <line x1="0" y1="120+d" x2="200+d" y2="120+d" stroke="#ffd700" stroke-width="2" opacity="0.6" />
          </g>

          <!-- Scattered Rays -->
          <g :transform="`rotate(${theta-90}, 200, 120)`">
             <line x1="200" y1="120" x2="400" y2="120" stroke="#ff4757" stroke-width="2" opacity="0.6" />
             <line x1="200+d" y1="120+d" x2="400" y2="120-d" stroke="#ff4757" stroke-width="2" opacity="0.6" />
          </g>

          <!-- Path Difference Highlight -->
          <path v-if="interference === 'constructive'" d="M 180, 120 L 220, 120" stroke="#ffd700" stroke-width="1" stroke-dasharray="2" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>掠射角 θ: {{ theta }}°</label>
              <div v-if="interference === 'constructive'" class="peak">✨ 满足相干加强条件</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节晶格间距 d</label>
             <el-slider v-model="d" :min="20" :max="60" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>调节入射角度 θ</label>
             <el-slider v-model="theta" :min="10" :max="80" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>布拉格定律描述了 X 射线在晶体平面上发生干涉的条件。只有当光程差等于波长的整数倍时，散射线才会同步加强。这是测定晶体结构与 DNA 双螺旋结构的物理基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XRayDiffractionViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      d: 30,
      theta: 30,
      wavelength: 30
    }
  },
  computed: {
    interference() {
      // 2d sin theta = n lambda
      let val = 2 * this.d * Math.sin(this.theta * Math.PI / 180);
      let n = val / this.wavelength;
      if (Math.abs(n - Math.round(n)) < 0.1) return 'constructive';
      return 'neutral';
    }
  }
}
</script>

<style scoped lang="scss">
.xray-diffraction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.peak { color: #ffd700; font-size: 0.7rem; margin-top: 4px; animation: glow 1s infinite alternate; }
@keyframes glow { from { opacity: 0.6; } to { opacity: 1; text-shadow: 0 0 5px #ffd700; } }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
